import { render, staticRenderFns } from "./SendEmailReceiptModal.vue?vue&type=template&id=2c3be3d1"
import script from "./SendEmailReceiptModal.vue?vue&type=script&lang=js"
export * from "./SendEmailReceiptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports